import React from "react";
import { ColorSelectorContainer } from "./style";
import NumberFormat from "components/numberFormat";
const ColorSelector = ({ colors, onChange, selected }) => {
  return (
    <ColorSelectorContainer>
      <h5>انتخاب رنگ</h5>
      {colors.map((color) => (
        <div
          className={`item ${selected?.id === color.id ? "selected" : ""}`}
          key={color.id}
          onClick={() => onChange({ color: color })}
        >
          <div className="title-area">
            <span
              className="color"
              style={{ backgroundColor: color.code }}
            ></span>
            {color.description}
          </div>
          <div className="price">
            {color.added_price ? <NumberFormat value={color.added_price}/> : ""}
          </div>
        </div>
      ))}
    </ColorSelectorContainer>
  );
};
export default ColorSelector;
